<template>
  <div class="oido-card-footer">
    <slot></slot>
    <div class="actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>


<script >



export default {



}
</script>


<style scoped>
.oido-card-footer {
  padding: 1rem 0.2rem 1rem;
  margin: 0 1.4rem;
  display: flex;
  border-top: 1px solid #f3f3f3;
  align-items: flex-end
}
.oido-card-footer .actions{
  display: flex;
  justify-content: flex-end;
  flex: 1;
}


</style>

<style>
.oido-card-footer .actions ion-button{
  min-height: 0;
  margin: 0;
  margin-left: 0.5rem;
  
}
.oido-card-footer .actions ion-button::part(native) {
  padding:0.1rem 0.3rem; 
}

.oido-card-footer .actions .oido-button{
  font-size: 0.8rem;
  font-weight: 450;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin-left: 1rem;
}
@media (max-width: 500px) {  
  .oido-card-footer .actions .oido-button .label{
    display: none;
  }
}

</style>


